import { render } from "./sidebar-video.vue?vue&type=template&id=0219bc11"
import script from "./sidebar-video.vue?vue&type=script&lang=js"
export * from "./sidebar-video.vue?vue&type=script&lang=js"
script.render = render

export default script